import { Controller } from "@hotwired/stimulus"
import { showConfirmModal } from "../lib/custom_confirm"

// Line Check Test (#18003): the Call button places a real phone call, so it
// asks first in the styled gl-modal (never the browser's confirm, MODAL-3),
// naming the number as it will be dialed. The server re-checks everything
// (DNC, premium rate, calling hours, caps); this only confirms intent.
//
// Same prevent → confirm → requestSubmit shape as confirm_submit_controller:
// the modal is async, so the first submit is always stopped and re-issued
// once accepted, and the re-issued submit is let through without a second
// prompt.
export const NANP_DIGITS = 10

export function formatPhone (raw) {
  let digits = String(raw || "").replace(/\D/g, "")
  if (digits.length === NANP_DIGITS + 1 && digits.startsWith("1")) digits = digits.slice(1)
  if (digits.length !== NANP_DIGITS) return String(raw || "").trim()

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}

export function confirmMessage (raw) {
  return `Call ${formatPhone(raw)} now? This places one short automated test call.`
}

export default class extends Controller {
  static targets = ["phone"]

  #confirmed = false
  #prompting = false

  confirm (event) {
    if (this.#confirmed) {
      this.#confirmed = false
      return
    }

    event.preventDefault()
    if (this.#prompting) return

    this.#prompting = true
    const phone = this.hasPhoneTarget ? this.phoneTarget.value : ""

    showConfirmModal(confirmMessage(phone), { title: "Place Test Call", confirmText: "Call Now", variant: "primary" })
      .then(
        (accepted) => {
          if (!accepted || !this.element.isConnected) return

          this.#confirmed = true
          try {
            this.element.requestSubmit()
          } catch (error) {
            this.#confirmed = false
            console.error("line-check-call-confirm: submitting the confirmed form failed", error)
          }
        },
        (error) => {
          // Fail closed: no dialog, no call.
          console.error("line-check-call-confirm: confirmation dialog failed", error)
        }
      )
      .finally(() => {
        this.#prompting = false
      })
  }
}
